module.exports = __webpack_public_path__ + "static/img/2.f590423.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/eng/2.png
// module id = 5QTx
// module chunks = 0